import { Button } from '@progress/kendo-react-buttons';
import { toastStore } from '../../stores/toast-store';
import { TiloPlayer } from '../../types/tilo/tilo-game';

interface PlayerRowProps {
  player: TiloPlayer;
  teamId: string;
  onGiveToken: (teamId: string, playerId: string) => Promise<void>;
  onKick: (playerId: string) => Promise<void>;
}

export const PlayerRow = ({ player, teamId, onGiveToken, onKick }: PlayerRowProps) => {
  const handleGiveToken = async () => {
    try {
      await onGiveToken(teamId, player._id);
      toastStore.show('Done', 'Token given', 'success', 3000);
    } catch {
      toastStore.show('Error', 'Failed to give token', 'error', 3000);
    }
  };

  const handleKick = async () => {
    if (!window.confirm(`Kick ${player.username || 'this player'}? This cannot be undone.`)) return;
    try {
      await onKick(player._id);
      toastStore.show('Done', 'Player kicked', 'success', 3000);
    } catch {
      toastStore.show('Error', 'Failed to kick player', 'error', 3000);
    }
  };

  return (
    <tr className={'tilo-player-row'}>
      <td className={'tilo-player-row__number'}>{player.number}</td>
      <td className={'tilo-player-row__name'}>
        {player.username
          ? player.username
          : <span className={'text-muted'}>Player {player.number}</span>}
      </td>
      <td className={'tilo-player-row__state'}>
        <span
          className={`tilo-dot ${player.state ? 'tilo-dot--online' : 'tilo-dot--offline'}`}
          title={player.state ? 'Online' : 'Offline'}
        />
      </td>
      <td className={'tilo-player-row__token'}>
        {player.token ? (
          <span
            className={'material-symbols-outlined'}
            style={{ fontSize: 18, color: '#14bf8b' }}>
            check_circle
          </span>
        ) : (
          <span className={'text-muted'} style={{ fontSize: 13 }}>—</span>
        )}
      </td>
      <td className={'tilo-player-row__give-token'}>
        <Button
          size={'small'}
          fillMode={'solid'}
          themeColor={'base'}
          title={'Give token'}
          disabled={!!player.token}
          onClick={handleGiveToken}>
          <span className={'material-symbols-outlined'} style={{ fontSize: 14 }}>
            toll
          </span>
        </Button>
      </td>
      <td className={'tilo-player-row__kick'}>
        <Button
          size={'small'}
          fillMode={'solid'}
          themeColor={'error'}
          title={'Kick player'}
          disabled={!player.taken}
          onClick={handleKick}>
          <span className={'material-symbols-outlined'} style={{ fontSize: 14 }}>
            person_remove
          </span>
        </Button>
      </td>
    </tr>
  );
};

export default PlayerRow;